import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'join',
  standalone: true
})
export class JoinPipe implements PipeTransform {
  public transform(value?: Array<any>, key?: string | null): string {
    if (value?.length) {
      if (!!key) {
        return value.map(v => v[key]).join(', ');
      } else {
        return value.join(', ');
      }
    } else {
      return '-';
    }
  }

}
